import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Input from "../../components/Input";
import { NavLink, useNavigate } from "react-router-dom";
import { useResetPasswordMutation } from "../../apis/loginApis";
import toast from "react-hot-toast";

type Props = {};

const ForgotPasswordSaudi = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const { mutate, isPending, isSuccess } = useResetPasswordMutation();

  const submitData = async (data: any) => {
    mutate(
      { ...data, type: "LM" },
      {
        onSuccess: (data) => {
          toast.success(data?.message);
          setTimeout(() => {
            navigate("/");
          }, 1000);
        },
        onError: (error) => {
          toast.error(`${error}`);
        },
      },
    );
  };

  return (
    <div className="bg-gradient-to-br from-[#f7f6ec] via-[#fff9df] to-[#ffe775] p-2">
      <div className="mx-auto flex   max-w-[1400px] overflow-hidden rounded-[38px] border border-white/70 bg-white/40 backdrop-blur-xl shadow-[0_28px_80px_rgba(36,30,10,0.14)]">
        {/* Left Login Panel */}
        <div className="w-[420px] shrink-0 bg-white/80 border-r border-[#ece8d6] p-6 flex flex-col">
          {/* Logo */}
          <div className="flex justify-start">
            <img
              //  src="/img/logo-tracktech-black.svg"
              src="/logo/logo-black.png"
              alt="Logo"
              className="2xl:w-52 w-52"
            />
          </div>

          <div className="mt-auto mb-auto">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-[#ffe99a] bg-[#fff7d0] px-4 py-2 text-xs font-bold text-[#8a6500]">
              <span className="h-2 w-2 rounded-full bg-green-500" />
              Live logistics workspace
            </div>
            <h1 className="text-3xl font-bold tracking-tight">
              Forgot Your Password
            </h1>
            <p className="mt-3 text-sm leading-6 text-gray-500">
              Please Enter Your Email For Reset Password !
            </p>

            <form
              className="space-y-4"
              id="loginForm"
              onSubmit={handleSubmit(submitData)}
            >
              <div className=" text-left space-y-1">
                <Input
                  name="email"
                  type="text"
                  title="Email"
                  placeholder="Enter Your Email"
                  inputClassName="rounded-lg w-full py-2.5 px-4 text-base text-[#1E1E1E] border border-[#D8D8D8]"
                  register={register}
                  error={errors.email}
                  validation={{
                    required: "Email is required",
                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Please enter a valid email address",
                    },
                  }}
                />
              </div>

              <button
                type="submit"
                disabled={isPending || isSuccess}
                className={`w-full flex justify-center items-center gap-2 font-semibold py-3 rounded-lg transition ${
                  isPending
                    ? "bg-[#212121] cursor-not-allowed text-[#ffffff]"
                    : "bg-[#FBD037] hover:bg-yellow-400 text-[#000000]"
                }`}
              >
                {isPending ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 000 16z"
                      />
                    </svg>
                    Sending Reset Link...
                  </>
                ) : (
                  "Forgot Password"
                )}
              </button>
              <p className="text-center">
                Back To{" "}
                <NavLink to="/" className="text-[#1a73e8] underline ">
                  Login
                </NavLink>
              </p>
            </form>
          </div>

          <p className="mt-10 text-xs text-gray-400">
            © 2026 Najiz Express · Powered by Gwarm Technologies PVT LTD .
          </p>
        </div>

        {/* Right Visual Section */}
        <div className="flex-1 p-10">
          {/* Top Chips */}
          <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
            <div className="flex flex-wrap gap-3">
              {[
                "📦 Shipments",
                "🧾 Orders",
                "🚚 Vehicles",
                "🔁 Inbound / Outbound",
              ].map((item) => (
                <div
                  key={item}
                  className="rounded-full border border-white/80 bg-white/70 px-4 py-2 text-sm font-semibold backdrop-blur"
                >
                  {item}
                </div>
              ))}
            </div>

            <div className="flex items-center gap-3 rounded-2xl bg-white/80 p-4 shadow-lg">
              <div>
                <div className="text-sm font-bold">Drivers Active Today</div>
                <div className="text-xs text-gray-500">12:30pm to 4:00pm</div>
              </div>

              <div className="flex -space-x-2">
                <div className="h-8 w-8 rounded-full bg-orange-400" />
                <div className="h-8 w-8 rounded-full bg-yellow-400" />
                <div className="h-8 w-8 rounded-full bg-green-400" />
              </div>
            </div>
          </div>

          {/* Main Hero */}
          <div className="grid h-[650px] grid-cols-[1.1fr_0.9fr] gap-5">
            <div className="relative overflow-hidden rounded-[32px]">
              <img
                src="https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1100&q=85"
                alt=""
                className="h-full w-full object-cover"
              />

              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

              <div className="absolute bottom-8 left-8 right-8 text-white">
                <h2 className="text-2xl font-bold">
                  Warehouse, fleet and shipment operations in one login
                  experience.
                </h2>

                <p className="mt-3 text-sm text-white/80">
                  Use realistic logistics visuals for inbound receiving, product
                  storage, vehicle movement and order tracking.
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-5">
              <div className="grid grid-cols-2 gap-4">
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1578575437130-527eed3abbec?auto=format&fit=crop&w=600&q=85"
                    alt="Warehouse worker handling products and packages"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                  <div className="absolute bottom-4 left-2 text-white">
                    <h2 className="text-lg font-bold">Inbound Receiving</h2>

                    <p className="text-sm text-white/80">
                      Scan, verify, sort, and store products
                    </p>
                  </div>
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=600&q=85"
                    alt="Truck fleet and logistics vehicle movement"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />

                  <div className="absolute bottom-4 left-2   text-white">
                    <h2 className="text-lg font-bold">Outbound Fleet</h2>

                    <p className="text-sm text-white/80">
                      Vehicle loading and route dispatch
                    </p>
                  </div>
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="https://images.unsplash.com/photo-1617347454431-f49d7ff5c3b1?auto=format&fit=crop&w=900&q=80"
                    alt="Driver Pickup"
                    className="h-full w-full object-cover"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
                <div className="relative overflow-hidden rounded-[32px] h-40">
                  <img
                    src="/img/image (1).png"
                    alt="Truck fleet and logistics vehicle movement"
                    className="h-44 object-center"
                  />

                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
              </div>

              <div className="flex-1 rounded-[28px] bg-white/80 space-y-4 p-5 backdrop-blur shadow-xl">
                <div className="flex justify-between items-center ">
                  <div className="flex items-center gap-2">
                    <div className="h-3 w-3 rounded-full bg-orange-400 backdrop-blur shadow-lg" />
                    <div className="h-3 w-3 rounded-full bg-yellow-400 backdrop-blur shadow-lg" />
                    <div className="h-3 w-3 rounded-full bg-green-400 backdrop-blur shadow-lg" />
                  </div>
                  <h3 className=" font-bold">Najiz Live Dispatch Board</h3>
                </div>

                <div className="space-y-3">
                  {[
                    "NJZ-9821 · Electronics",
                    "NJZ-3401 · Medical Supplies",
                    "NJZ-1109 · Auto Parts",
                  ].map((item) => (
                    <div
                      key={item}
                      className="flex items-center justify-between rounded-2xl border bg-white p-3"
                    >
                      <div>
                        <div className="font-semibold">{item}</div>
                        <div className="text-xs text-gray-500">
                          Outbound Route
                        </div>
                      </div>

                      <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-bold text-green-700">
                        Active
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Stats */}
          <div className="mt-5 grid grid-cols-4 gap-4">
            {[
              ["Inbound Loads", "284"],
              ["Outbound Orders", "956"],
              ["Product Items", "8.6k"],
              ["Route ETA", "24m"],
            ].map(([label, value]) => (
              <div
                key={label}
                className="rounded-3xl bg-white/70 p-5 backdrop-blur shadow-lg"
              >
                <div className="text-xs font-bold uppercase text-gray-500">
                  {label}
                </div>

                <div className="text-xl font-bold">{value}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordSaudi;
